(function () {
  var HIDE_ID = "6b90920c-b280-48a1-bb0f-c86352a4636a";
  var current = window.jdgmBuildMediaCards;

  function wrap(fn) {
    if (typeof fn !== "function" || fn.__rncHideBlank) return fn;

    function wrapped(root, settings, mode) {
      if (mode && Array.isArray(mode.reviews)) {
        var next = mode.reviews.filter(function (review) {
          return !review || review.uuid !== HIDE_ID;
        });
        if (next.length !== mode.reviews.length) {
          mode.reviews = next;
          mode.revCount = next.length;
        }
      }
      return fn.call(this, root, settings, mode);
    }

    wrapped.__rncHideBlank = true;
    return wrapped;
  }

  current = wrap(current);

  try {
    Object.defineProperty(window, "jdgmBuildMediaCards", {
      configurable: true,
      enumerable: true,
      get: function () {
        return current;
      },
      set: function (fn) {
        current = wrap(fn);
      }
    });
  } catch (error) {
    var tries = 0;
    var timer = setInterval(function () {
      if (typeof window.jdgmBuildMediaCards === "function") {
        window.jdgmBuildMediaCards = wrap(window.jdgmBuildMediaCards);
      }
      tries += 1;
      if (tries > 400) clearInterval(timer);
    }, 25);
  }
})();
